import React from 'react'
import { track } from '@SonarCX/lib/mixpanel'
import { getContactsActivity, getTaskActivity } from '@SonarCX/lib/idb'

import HomeTasks from '../Tasks'
import HomeContacts from '../Contacts'

import useStyles from '../../styles'

interface RecentsColumnProps {
  user: APIUser
  env: APIEnvironment
}

const RecentsColumn: React.FC<RecentsColumnProps> = ({ user, env }) => {
  const [latestTasks, setLatestTasks] = React.useState<string[]>([])
  const [latestContacts, setLatestContacts] = React.useState<string[]>([])
  const [initialLoad, setInitialLoad] = React.useState(false)

  const classes = useStyles()

  React.useEffect(() => {
    const getLatestActivity = async () => {
      const [tasks, contacts] = await Promise.all([
        getTaskActivity(user.id, env.name),
        getContactsActivity(user.id, env.name)
      ])
      setLatestTasks(tasks ?? [])
      setLatestContacts(contacts ?? [])
      setInitialLoad(true)
    }

    getLatestActivity()
  }, [env, user])

  React.useEffect(() => {
    track('RECENTS_TAB_VIEWED')
  }, [])

  return (
    <>
      {initialLoad &&
        (latestTasks.length + latestContacts.length === 0 ? (
          <h4 className={classes.subHeader}>You have no recent activity</h4>
        ) : (
          <h4 className={classes.subHeader}>Continue where you left off</h4>
        ))}

      {initialLoad && latestTasks.length > 0 && (
        <HomeTasks latestTasks={latestTasks} />
      )}

      {initialLoad && latestContacts.length > 0 && (
        <HomeContacts latestContacts={latestContacts} />
      )}
    </>
  )
}

export default RecentsColumn
